import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import {getEnv} from './getEnv';

// @ts-ignore
const environment = getEnv();
const enabled = !!['staging', 'sandbox', 'prod'].includes(environment)

// Ratelimit
const eventLimiter = {}

Sentry.init({
  dsn: 'https://44a93f57d2044401bcc5ebbd4aad3008@o299470.ingest.sentry.io/6653755',
  integrations: [new BrowserTracing()],
  enabled,
  environment: environment || 'staging',
  beforeSend: (event, hint) => {
    const msg = hint && hint.originalException.message

    // Error rate limit
    if (msg && msg in eventLimiter) {
      return null
    }

    eventLimiter[msg] = true

    setTimeout(() => {
      delete eventLimiter[msg]
    }, 1 * 60 * 10000)

    return event
  },
})

export default Sentry
